import STRINGS from "../globals/strings.jsx"
import IMAGES from "../globals/images.jsx"

function YetBat() {
    return (
        <div>
            <div>
                <img style={{width: "100%"}} src={IMAGES.YETBAT} alt={STRINGS.NO_DATA_FOUND} />
            </div>
        </div>
    )
}

export default YetBat